// src/services/apiMe.tsx
// Session/me — one place to read the current session + ownership, typed.

import { http } from './http';

export type MeUser = {
  id: number | null;
  email: string | null;
  email_verified: boolean;
  age_verified: boolean;
  name?: string | null;
  birthdate?: string | null;
  gender?: string | null;
  telegram_id?: string | null;
  session_id?: string | null;
};

export type MeResponse = {
  authenticated: boolean;
  env: 'prod' | 'staging' | string;
  user?: MeUser;
  ownedProducts: string[];
  memberships: unknown[];
  hasAccess: boolean;
};

/** GET /me — session snapshot (cookie-based) */
export async function getMe(): Promise<MeResponse> {
  // Some http() typings return Promise<Response | T>. Normalize to MeResponse.
  const data = await (http as any)('/me');
  return data as MeResponse;
}

/** Convenience: does the current user own a given product id? */
export async function ownsProduct(productId: string): Promise<boolean> {
  const me = await getMe();
  return Array.isArray(me?.ownedProducts) && me.ownedProducts.includes(productId);
}
